import { Theme } from "@material-ui/core";
import { hexToRGB } from "src/util";

export const styles = (theme: Theme) => ({
  tabs: {
    backgroundColor: `rgba(${hexToRGB(theme.palette.primary.main)}, 0.1)`,
    borderRadius: "4px",
  },
  tabOverride: {
    [theme.breakpoints.up("sm")]: {
      "&.MuiTab-root": {
        minWidth: "100px",
      },
    },
  },
});



// WEBPACK FOOTER //
// ./src/pages/director/seasons/components/seasons-sport-editor/styles.ts